import { getRequestIdle } from './idle.js';
import { loadJS } from './resource.js';
const config = {
    appkey: '0WEB0QWE9S4O8HO0',
    versionCode: '0.0.1',
    strictMode: false,
};
let tracker;
const taskQueue = [];
export class Tracker {
    constructor(init = {}) {
        this.requestIdle = getRequestIdle();
        if (tracker) {
            return tracker;
        }
        this.requestIdle(() => this.init(init));
    }
    async init(init) {
        var _a;
        if (typeof init.beaconAction === 'function') {
            this.client = new init.beaconAction(config);
        }
        else if (init.beaconAction) {
            this.client = init.beaconAction;
        }
        else {
            try {
                const sdk = 'https://beacon.cdn.qq.com/sdk/4.5.8/beacon_web.min.js';
                const amdWindow = window;
                if (typeof amdWindow.require === 'function' && ((_a = amdWindow.define) === null || _a === void 0 ? void 0 : _a.amd)) {
                    amdWindow.require([sdk], (BA) => {
                        this.client = new BA(config);
                    });
                }
                else {
                    await loadJS(sdk);
                    this.client = new BeaconAction(config);
                }
            }
            catch (ex) {
                console.warn('Failed to initialize Beacon Web SDK.');
                return;
            }
        }
        // 更新外部 tracker (eslint 错误地认为 tracker is a local variable)
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        tracker = this;
        // 清理未上报的队列
        taskQueue.forEach(([name, args]) => {
            if (name === 'onUserAction') {
                tracker.report(args[0], args[1]);
            }
        });
        taskQueue.length = 0;
    }
    report(eventCode, eventData) {
        this.requestIdle(() => {
            try {
                this.client.onUserAction(eventCode, eventData);
            }
            catch (ex) {
                console.warn(`Error happened on "onUserAction(${eventCode}, ${eventData})"`, ex);
            }
        });
    }
}
/**
 * eventCode、eventData 字段需要在
 * https://beacon.woa.com/datamanager/exeditor3/data-resource/detail/1019922?resourceType=PLAIN&tabType=events-manage
 * 注册
 */
export function report(eventCode, eventData) {
    if (tracker) {
        tracker.report(eventCode, eventData);
    }
    else {
        taskQueue.push(['onUserAction', [eventCode, eventData]]);
    }
}
//# sourceMappingURL=tracker.js.map